import { getPortausCompanyOverride } from '@/utils/market-utils';

const countryCode = localStorage.getItem('countryCode') || 'QC';
const tax = localStorage.getItem('tax') || 'IN';
export default () => ({
  actionBar: {
    country: countryCode,
    tax: tax,
  },
  // Hidden ?company= preview override. Mirrored into Vuex so the banner is
  // reactive — reading localStorage from a computed gives it no reactive
  // dependency, so Vue caches the result and the banner never updates.
  portausCompanyOverride: getPortausCompanyOverride(),
});
